import i18next from 'i18next';

i18next.addResources('es', 'technicalSheet', {
  general: 'General',
  countries: 'Países',
  area: 'Ámbito',
  stateOfProject: 'Estado de la acción',
  finance: 'Costo y financiamiento',
  totalInvestment: 'Inversión total',
  range: 'Alcance',
  objectives: 'Objetivos',
  description: 'Descripción',
  amount: 'Monto',
  type: 'Tipo',
  fundingTypes: 'Tipos de financiamiento',
  funders: 'Financiadores',
  source: 'Fuente',
  etapa: 'Etapa',
  themes: 'Temas',
  subthemes: 'Subtemas',
  types: 'Tipo',
  territories: 'Territorios',
  responsibles: 'Responsables',
  term: 'Plazo',
  projectSheet: 'Ficha del proyecto o acción'
});

i18next.addResources('en', 'technicalSheet', {
  general: 'General',
  countries: 'Countries',
  area: 'Area',
  stateOfProject: 'Action status',
  finance: 'Cost and financing',
  totalInvestment: 'Total investment',
  range: 'Scope',
  objectives: 'Objectives',
  description: 'Description',
  amount: 'Amount',
  type: 'Type',
  fundingTypes: 'Funding types',
  funders: 'Funders',
  source: 'Source',
  etapa: 'Stage',
  themes: 'Themes',
  subthemes: 'Subthemes',
  types: 'Type',
  territories: 'Territories',
  responsibles: 'Responsible parties',
  term: 'Term',
  projectSheet: 'Project or action sheet'
});

i18next.addResources('pt', 'technicalSheet', {
  general: 'Geral',
  countries: 'Países',
  area: 'Âmbito',
  stateOfProject: 'Estado da ação',
  finance: 'Custo e financiamento',
  totalInvestment: 'Investimento total',
  range: 'Alcance',
  objectives: 'Objetivos',
  description: 'Descrição',
  amount: 'Valor',
  type: 'Tipo',
  fundingTypes: 'Tipos de financiamento',
  funders: 'Financiadores',
  source: 'Fonte',
  etapa: 'Etapa',
  themes: 'Temas',
  subthemes: 'Subtemas',
  types: 'Tipo',
  territories: 'Territórios',
  responsibles: 'Responsáveis',
  term: 'Prazo',
  projectSheet: 'Ficha do projeto ou ação'
});
